/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

// MAIN COLORS - VUESAX THEME COLORS
const initialConfig = {
  kaLab : 'Ka Lab MIT_LAB',
  nip : '1234567890',
  secretChiper : 'Allah Muhammad',
  extUrlAccess : 'https://helix.healtri.com/pdf/'
}

export default initialConfig
